import { Component } from '@angular/core';

@Component({
  selector: 'app-success-dialog',
  imports: [],
  templateUrl: './success-dialog.component.html',
  styleUrl: './success-dialog.component.scss'
})
export class SuccessDialogComponent {
  id!: string;
  message!: string;
}
